var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "PageNotFound" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8 col-md-offset-4" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.msg))]),
            _vm._v(" "),
            _c("h5", [_vm._v("There's nothing here.")]),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "page-not-found-link", attrs: { to: "/" } },
              [_vm._v("Take me home.")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4104abc3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4104abc3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/PageNotFound.vue
// module id = 1810
// module chunks = 0